export class PushNotificationService {
  private static instance: PushNotificationService;

  public static getInstance(): PushNotificationService {
    if (!PushNotificationService.instance) {
      PushNotificationService.instance = new PushNotificationService();
    }
    return PushNotificationService.instance;
  }

  public isSupported(): boolean {
    return typeof window !== 'undefined' && 'Notification' in window;
  }

  public getPermissionStatus(): NotificationPermission | 'unsupported' {
    if (!this.isSupported()) return 'unsupported';
    return Notification.permission;
  }

  public async requestPermission(): Promise<boolean> {
    if (!this.isSupported()) return false;
    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (err) {
      console.error('Erro ao solicitar permissão de notificação:', err);
      return false;
    }
  }

  public async sendNotification(title: string, options?: NotificationOptions & { body?: string; icon?: string; badge?: string; tag?: string }) {
    if (!this.isSupported()) return false;

    if (Notification.permission !== 'granted') {
      const granted = await this.requestPermission();
      if (!granted) return false;
    }

    const defaultOptions: any = {
      icon: '/pwa-192x192.png',
      badge: '/pwa-192x192.png',
      vibrate: [200, 100, 200],
      requireInteraction: true,
      ...options,
    };

    try {
      // Tenta enviar via ServiceWorker (para PWA em tela de bloqueio e segundo plano)
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.ready;
        if (registration && 'showNotification' in registration) {
          await registration.showNotification(title, defaultOptions);
          return true;
        }
      }

      // Fallback para Notification API padrão
      new Notification(title, defaultOptions);
      return true;
    } catch (err) {
      console.error('Erro ao disparar notificação:', err);
      return false;
    }
  }

  public notifyNovaOS(osId: number | string, descricao?: string) {
    return this.sendNotification(`🚨 Nova Ordem de Serviço #${osId}`, {
      body: descricao ? `Descrição: ${descricao}` : 'Uma nova OS foi atribuída e aguarda atendimento.',
      tag: `os-${osId}`,
    });
  }

  public notifyAtualizacaoRota(nomeRoteiro: string) {
    return this.sendNotification('🗺️ Rota Atualizada', {
      body: `O roteiro "${nomeRoteiro}" foi atualizado pelo painel administrativo.`,
      tag: 'roteiro-update',
    });
  }
}

export const pushNotificationService = PushNotificationService.getInstance();
